/* eslint-disable */
export default {
  _rolling_no_oneregular: 'rolling_no_oneregular',
}